export function CsrfToken() {
    return <input type='hidden' name='csrf_token' value={FLASK_CSRF} />;
}
